import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './Blur.module.scss'

const propTypes = {
  className: PropTypes.string,
  amount: PropTypes.oneOf(['most', 'more', 'less']),
  enabled: PropTypes.bool
}

const defaultProps = {
  amount: 'more',
  enabled: true
}

const Blur = ({ amount, className, enabled, ...restProps }) => (
  <div
    className={classnames(
      className,
      enabled && styles.root,
      enabled && styles[`amount-${amount}`]
    )}
    aria-hidden='true'
    {...restProps}
  />
)

Blur.propTypes = propTypes
Blur.defaultProps = defaultProps

export default Blur
